import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { ReactComponent as Cross } from "assets/images/icons/Close.svg";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import "./Dialog.scss";

/**
 * A re-usable Dialog (modal) component.
 */
const Dialog = function (props) {
  const { show: isShowing, onHide, title, children, isLoading, size = "", className, viewOrders } = props;
  const [show, setShow] = useState(isShowing);

  useEffect(() => {
    setShow(isShowing);
  }, [isShowing]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onHide]);

  const headerClassName = viewOrders ? "view-orders-header" : "dialog-header";

  if (isLoading)
    return (
      <Modal show={show} size={size} keyboard onHide={onHide} centered>
        <Modal.Header className="border-0 p-0 m-0 dialog-header">
          <div className="w-100 d-flex flex-row justify-content-between align-items-center">
            <Modal.Title className="dialog-title">{title}</Modal.Title>
            {onHide && (
              <Cross stroke="black" className="dialog-cross" alt="close dialog" data-testid="close" onClick={onHide} />
            )}
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <LoadingSkeleton rows={3} className="p-0" isListing />
        </Modal.Body>
      </Modal>
    );

  return (
    <Modal contentClassName={`${className}`} size={size} show={show} keyboard onHide={onHide} centered>
      <Modal.Header className={`border-0 p-0 m-0 ${headerClassName}`}>
        <div className="w-100 d-flex flex-row justify-content-between align-items-center ">
          {title ? <Modal.Title className="widget-title">{title}</Modal.Title> : <div />}
          {onHide && (
            <Cross stroke="black" className="dialog-cross" alt="close dialog" data-testid="close" onClick={onHide} />
          )}
        </div>
      </Modal.Header>
      <Modal.Body className="p-0">{children}</Modal.Body>
    </Modal>
  );
};

Dialog.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  isLoading: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
  viewOrders: PropTypes.bool,
};

Dialog.defaultProps = {
  onHide: () => {},
  isLoading: false,
  size: "",
  className: "",
  title: "",
  viewOrders: false,
};

export default Dialog;
